// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StartCall__container-bad315 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 295px;
  padding: 56px;
}

.StartCall__image-e51143 {
  width: 120px;
  height: 120px;
  margin-bottom: 24px;
}

.StartCall__title-f11bf4 {
  color: var(--base-110);
  font: var(--font-title-6);
  letter-spacing: var(--font-spacing-title-6);
}

.StartCall__sub-title-de38a8 {
  color: var(--base-80);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  margin-bottom: 24px;
}

.StartCall__join-button-b63e12 {
  width: 100%;
  margin-bottom: 8px;
}

.StartCall__cancel-button-aa2b3b {
  width: 100%;
}

@media (max-width: 1024px) {
  .StartCall__container-bad315 {
    padding: 0;
    margin-top: 24px;
  }
}
@media (max-width: 768px) {
  .StartCall__image-e51143 {
    width: 72px;
    height: 72px;
    margin-bottom: 16px;
  }
  .StartCall__container-bad315 {
    width: 100%;
    max-width: 396px;
    padding: 0;
    margin-top: 24px;
  }
}
.StartCall__asking-to-join-a6283c {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--base-110, #202020);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  width: 100%;
  margin-bottom: 8px;
  height: 48px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/RoomCallPreviewPopup/StartCall/StartCall.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,yBAAA;EACA,2CAAA;AACF;;AAEA;EACE,qBAAA;EACA,wBAAA;EACA,0CAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE;IACE,UAAA;IACA,gBAAA;EACF;AACF;AAEA;EACE;IACE,WAAA;IACA,YAAA;IACA,mBAAA;EAAF;EAEA;IACE,WAAA;IACA,gBAAA;IACA,UAAA;IACA,gBAAA;EAAF;AACF;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,wBAAA;EACA,0CAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;AADF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 295px;\n  padding: 56px;\n}\n\n.image {\n  width: 120px;\n  height: 120px;\n  margin-bottom: 24px;\n}\n\n.title {\n  color: var(--base-110);\n  font: var(--font-title-6);\n  letter-spacing: var(--font-spacing-title-6);\n}\n\n.sub-title {\n  color: var(--base-80);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  margin-bottom: 24px;\n}\n\n.join-button {\n  width: 100%;\n  margin-bottom: 8px;\n}\n\n.cancel-button {\n  width: 100%;\n}\n\n@media (max-width: 1024px) {\n  .container {\n    padding: 0;\n    margin-top: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .image {\n    width: 72px;\n    height: 72px;\n    margin-bottom: 16px;\n  }\n  .container {\n    width: 100%;\n    max-width: 396px;\n    padding: 0;\n    margin-top: 24px;\n  }\n}\n\n.asking-to-join {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--base-110, #202020);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  width: 100%;\n  margin-bottom: 8px;\n  height: 48px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StartCall__container-bad315`,
	"image": `StartCall__image-e51143`,
	"title": `StartCall__title-f11bf4`,
	"sub-title": `StartCall__sub-title-de38a8`,
	"subTitle": `StartCall__sub-title-de38a8`,
	"join-button": `StartCall__join-button-b63e12`,
	"joinButton": `StartCall__join-button-b63e12`,
	"cancel-button": `StartCall__cancel-button-aa2b3b`,
	"cancelButton": `StartCall__cancel-button-aa2b3b`,
	"asking-to-join": `StartCall__asking-to-join-a6283c`,
	"askingToJoin": `StartCall__asking-to-join-a6283c`
};
module.exports = ___CSS_LOADER_EXPORT___;
